module.exports = __webpack_public_path__ + "static/img/demo_user5.dffaca5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/placeholders/demo_user5.png
// module id = oLQv
// module chunks = 31